import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import ApiEventos from '../services/eventoService';
import ApiAluno from '../services/alunoService';
import ApiAlunoTemp from '../services/alunoTempService';
import ApiFaixas from '../services/faixaService';
import ApiMunicipios from '../services/municipioService';
import ApiDivisoes from '../services/divisaoService';

import ValorMonetario from '../components/ValorMonetario';
import RangeSelect from '../components/RangeSelect';
import FormaPagamento from '../components/FormaPagamento';

const getAtletaInicial = () => ({
    id: '',
    nome: '',
    sexo: '',
    cpf: '',
    email: '',
    data_nascimento: '',
    peso: '',
    categoria_faixa: '',
    municipio_id: '',
    maiorIdade: '',
    idade: null,
    categorias: [],
    categoria: '',
    codigo: '',
    divisao: '',
    rangePeso: null,
});

export default function GyeorugiTk3NaoFiliado({ evento, onFinalizado }) {
    const navigate = useNavigate();
    const boxPedidoRef = useRef(null);
    const processingRef = useRef(false);

    const [listaFaixas, setListaFaixas] = useState([]);
    const [listaMunicipios, setListaMunicipios] = useState([]);

    const [atletas, setAtletas] = useState([
        getAtletaInicial(),
        getAtletaInicial(),
        getAtletaInicial(),
    ]);

    const [dadosEquipe, setDadosEquipe] = useState({
        academia: '',
        tecnico: '',
    });

    const [pedido, setPedido] = useState(null);
    const [inscricaoFinalizada, setInscricaoFinalizada] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        obterListaFaixas();
        obterListaMunicipios();
    }, []);

    const obterListaFaixas = async () => {
        const response = await ApiFaixas.listar();

        if (response.statusRetorno !== 200) {
            Swal.fire({
                title: 'Erro ao carregar faixas!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Ok',
            });

            return;
        }

        setListaFaixas(response.data || []);
    };

    const obterListaMunicipios = async () => {
        const response = await ApiMunicipios.listar();

        if (response.statusRetorno !== 200) {
            Swal.fire({
                title: 'Erro ao carregar Municípios!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Ok',
            });

            return;
        }

        setListaMunicipios(response.data || []);
    };

    const handleChangeEquipe = (campo, valor) => {
        setDadosEquipe((prev) => ({
            ...prev,
            [campo]: valor,
        }));
    };

    const handleChangeAtleta = (index, campo, valor) => {
        setAtletas((prev) =>
            prev.map((atleta, i) =>
                i === index
                    ? { ...atleta, [campo]: valor }
                    : atleta
            )
        );
    };

    const atualizarAtleta = (index, dados) => {
        setAtletas((prev) =>
            prev.map((atleta, i) =>
                i === index
                    ? { ...atleta, ...dados }
                    : atleta
            )
        );
    };

    const validarCpf = (cpf) => {
        const cpfLimpo = (cpf || '').replace(/\D/g, '');

        if (cpfLimpo.length !== 11) return false;
        if (/^(\d)\1{10}$/.test(cpfLimpo)) return false;

        let soma = 0;
        let resto;

        for (let i = 1; i <= 9; i++) {
            soma += parseInt(cpfLimpo.substring(i - 1, i), 10) * (11 - i);
        }

        resto = (soma * 10) % 11;

        if (resto === 10 || resto === 11) resto = 0;

        if (resto !== parseInt(cpfLimpo.substring(9, 10), 10)) {
            return false;
        }

        soma = 0;

        for (let i = 1; i <= 10; i++) {
            soma += parseInt(cpfLimpo.substring(i - 1, i), 10) * (12 - i);
        }

        resto = (soma * 10) % 11;

        if (resto === 10 || resto === 11) resto = 0;

        return resto === parseInt(cpfLimpo.substring(10, 11), 10);
    };

    const obterCategoriasPorIdade = async (maiorIdade, idadeNoFimDoAno) => {
        const response = await ApiDivisoes.listarPorTipoIdade(maiorIdade);

        if (response.statusRetorno !== 200) {
            throw new Error(response.message || 'Erro ao obter divisões.');
        }

        return (response.data || []).filter((item) => {
            const idadeInicio = parseInt(item.idade_inicio, 10);
            const idadeFim = parseInt(item.idade_fim, 10);

            return idadeNoFimDoAno >= idadeInicio && idadeNoFimDoAno <= idadeFim;
        });
    };

    const atualizarDadosNascimento = async (index, dataNascimento) => {
        if (!dataNascimento) return;

        const nascimento = new Date(dataNascimento);

        if (isNaN(nascimento.getTime())) return;

        const hoje = new Date();
        const anoNascimento = nascimento.getFullYear();
        const anoAtual = hoje.getFullYear();

        if (anoNascimento < 1900 || anoNascimento > anoAtual) return;

        let idadeCalculada = anoAtual - anoNascimento;
        const mes = hoje.getMonth() - nascimento.getMonth();

        if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
            idadeCalculada--;
        }

        const idadeNoFimDoAno = anoAtual - anoNascimento;
        const maiorIdade = idadeNoFimDoAno >= 18 ? '1' : '0';

        try {
            const categorias = await obterCategoriasPorIdade(
                maiorIdade,
                idadeNoFimDoAno
            );

            atualizarAtleta(index, {
                data_nascimento: dataNascimento,
                idade: idadeCalculada,
                maiorIdade,
                categorias,
                categoria: '',
                codigo: '',
                divisao: '',
                rangePeso: null,
                peso: '',
            });
        } catch (error) {
            Swal.fire({
                title: 'Erro ao obter divisões!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'Ok',
            });
        }
    };

    const atualizarCategoria = (index, categoriaId, sexo = null) => {
        const atleta = atletas[index];

        if (!atleta) return;

        const sexoAtual = sexo || atleta.sexo;

        const categoriaSelecionada = (atleta.categorias || []).find(
            (item) => Number(item.id) === Number(categoriaId)
        );

        if (!categoriaSelecionada) {
            atualizarAtleta(index, {
                categoria: '',
                codigo: '',
                divisao: '',
                rangePeso: null,
                peso: '',
            });

            return;
        }

        let rangePeso;

        if (evento?.tipoEvento === 3) {
            rangePeso = sexoAtual === 'Masculino'
                ? categoriaSelecionada.range_peso_masculino_jir
                : categoriaSelecionada.range_peso_feminino_jir;
        } else {
            rangePeso = sexoAtual === 'Masculino'
                ? categoriaSelecionada.range_peso_masculino
                : categoriaSelecionada.range_peso_feminino;
        }

        atualizarAtleta(index, {
            categoria: Number(categoriaId),
            codigo: categoriaSelecionada.codigo,
            divisao: categoriaSelecionada.divisao,
            rangePeso,
            peso: '',
        });
    };

    const buscarCpf = async (index, cpfDigitado) => {
        const cpfLimpo = cpfDigitado.replace(/\D/g, '');

        if (cpfLimpo.length !== 11) return;

        try {
            const retorno = await ApiAluno.getAlunoPorCpf(cpfLimpo);

            if (retorno.data && retorno.data.length > 0) {
                await Swal.fire({
                    title: 'Atenção',
                    text: 'Este CPF já está vinculado à FETRON!',
                    icon: 'warning',
                    confirmButtonText: 'Efetuar Login',
                });

                navigate('/login');
                return;
            }

            const response = await ApiAlunoTemp.obterPorCpf(cpfLimpo);

            if (!response?.data) return;

            const aluno = response.data;

            atualizarAtleta(index, {
                id: aluno.id || '',
                nome: aluno.nome || '',
                sexo: aluno.sexo || '',
                cpf: aluno.cpf || cpfDigitado,
                email: aluno.email || '',
                data_nascimento: aluno.dataNascimento || '',
                categoria_faixa: aluno.faixaId?.toString() || '',
                municipio_id: aluno.municipioId || '',
            });

            setDadosEquipe((prev) => ({
                academia: prev.academia || aluno.academia || '',
                tecnico: prev.tecnico || aluno.tecnico || '',
            }));

            if (aluno.dataNascimento) {
                await atualizarDadosNascimento(index, aluno.dataNascimento);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeCpf = async (index, valor) => {
        handleChangeAtleta(index, 'cpf', valor);

        const cpfLimpo = valor.replace(/\D/g, '');

        if (cpfLimpo.length !== 11) return;

        if (!validarCpf(valor)) {
            Swal.fire({
                title: 'CPF inválido!',
                text: 'Número de CPF digitado é inválido.',
                icon: 'error',
                confirmButtonText: 'Ok',
            });

            return;
        }

        await buscarCpf(index, valor);
    };

    const handleBlurCpf = async (index) => {
        const atleta = atletas[index];

        if (!atleta) return;

        const cpfLimpo = (atleta.cpf || '').replace(/\D/g, '');

        if (cpfLimpo.length === 11 && validarCpf(atleta.cpf)) {
            await buscarCpf(index, atleta.cpf);
        }
    };

    const validarAtleta = (atleta, index) => {
        const erros = [];
        const prefixo = `• Atleta ${index + 1}: `;

        if (!atleta.cpf) erros.push(`${prefixo}informe o CPF.`);
        if (atleta.cpf && !validarCpf(atleta.cpf)) erros.push(`${prefixo}CPF inválido.`);
        if (!atleta.nome) erros.push(`${prefixo}informe o nome.`);
        if (!atleta.sexo) erros.push(`${prefixo}informe o sexo.`);
        if (!atleta.email) erros.push(`${prefixo}informe o email.`);

        if (!atleta.categoria_faixa || atleta.categoria_faixa === '0') {
            erros.push(`${prefixo}a graduação é obrigatória.`);
        }

        if (!atleta.data_nascimento) {
            erros.push(`${prefixo}informe a data de nascimento.`);
        }

        if (!atleta.municipio_id) {
            erros.push(`${prefixo}informe o município.`);
        }

        if (!atleta.categoria) {
            erros.push(`${prefixo}selecione a categoria.`);
        }

        if (!atleta.peso) {
            erros.push(`${prefixo}informe o peso.`);
        }

        if (evento?.tipoEvento === 3 && atleta.data_nascimento) {
            const nascimento = new Date(atleta.data_nascimento);
            const idadeFimAno = new Date().getFullYear() - nascimento.getFullYear();

            if (idadeFimAno < 16) {
                erros.push(
                    `${prefixo}a idade mínima para o Gyeorugi neste evento é 16 anos.`
                );
            }

            if (Number(atleta.categoria_faixa) < 9) {
                erros.push(
                    `${prefixo}a graduação mínima permitida para este evento não foi atingida.`
                );
            }
        }

        return erros;
    };

    const validarEquipe = () => {
        const erros = [];

        if (!dadosEquipe.academia) {
            erros.push('• Informe a academia da equipe.');
        }

        if (!dadosEquipe.tecnico) {
            erros.push('• Informe o técnico da equipe.');
        }

        atletas.forEach((atleta, index) => {
            erros.push(...validarAtleta(atleta, index));
        });

        const cpfs = atletas
            .map((atleta) => (atleta.cpf || '').replace(/\D/g, ''))
            .filter(Boolean);

        if (new Set(cpfs).size !== cpfs.length) {
            erros.push('• Os três atletas da equipe TK3 devem ser diferentes.');
        }

        const divisoes = atletas
            .map((atleta) =>
                atleta.divisao && atleta.codigo
                    ? `${atleta.divisao}/${atleta.codigo}`
                    : ''
            )
            .filter(Boolean);

        if (divisoes.length === 3 && new Set(divisoes).size !== 1) {
            erros.push(
                '• Os três atletas da equipe TK3 devem pertencer à mesma categoria/divisão.'
            );
        }

        return erros;
    };

    const salvarAtletaTemp = async (atleta) => {
        return ApiAlunoTemp.save({
            ...atleta,
            academia: dadosEquipe.academia,
            tecnico: dadosEquipe.tecnico,
        });
    };

    const handleInscricao = async () => {
        if (processingRef.current) return;

        const erros = validarEquipe();

        if (erros.length > 0) {
            Swal.fire({
                title: 'Atenção!',
                html: erros.join('<br>'),
                icon: 'warning',
                confirmButtonText: 'Ok',
            });

            return;
        }

        processingRef.current = true;
        setIsProcessing(true);

        try {
            const alunosSalvos = [];

            for (let index = 0; index < atletas.length; index++) {
                const atleta = atletas[index];
                const response = await salvarAtletaTemp(atleta);

                if (response.status !== 'success') {
                    Swal.fire({
                        title: 'Atenção',
                        text: `Erro ao cadastrar o atleta ${index + 1}: ${response.message}`,
                        icon: 'error',
                        confirmButtonText: 'Ok',
                    });

                    return;
                }

                alunosSalvos.push(response.aluno);
            }

            const primeiroAtleta = atletas[0];

            const divisaoCodigo = primeiroAtleta.divisao && primeiroAtleta.codigo
                ? `${primeiroAtleta.divisao}/${primeiroAtleta.codigo}`
                : '';

            const payload = {
                eventoId: evento.id,
                gerarPedido: evento.tipoEvento !== 3,
                nome: primeiroAtleta.nome,
                cpf: primeiroAtleta.cpf,
                email: primeiroAtleta.email,
                divisaoCodigo,
                alunos: alunosSalvos.map((aluno, index) => ({
                    alunoTempId: aluno.id,
                    peso: atletas[index].peso,
                })),
            };

            const response = await ApiEventos.pagamentoSemVinculoTk3(payload);

            if (response.statusRetorno !== 200) {
                Swal.fire({
                    title: 'Houve um erro ao realizar a inscrição!',
                    text: response.message || 'Erro na API.',
                    icon: 'error',
                    confirmButtonText: 'Ok',
                });

                return;
            }

            if (response.status === 'error') {
                Swal.fire({
                    title: 'Hummm!',
                    text: response.message,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });

                return;
            }

            if (response.pedido?.status === 'error') {
                Swal.fire({
                    title: 'Hummm!',
                    text: response.pedido.message,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });

                return;
            }

            if (evento.tipoEvento === 3 || response.pedido?.semPedido) {
                setInscricaoFinalizada(true);

                if (onFinalizado) {
                    onFinalizado();
                }

                Swal.fire({
                    title: 'Inscrição realizada!',
                    text: 'Equipe TK3 inscrita com sucesso.',
                    icon: 'success',
                    confirmButtonText: 'Ok',
                });

                return;
            }

            setPedido(response.pedido);

            if (onFinalizado) {
                onFinalizado();
            }

            setTimeout(() => {
                boxPedidoRef.current?.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 100);

            Swal.fire({
                title: 'Equipe cadastrada com sucesso!',
                text: 'Seu pagamento foi gerado.',
                icon: 'success',
                confirmButtonText: 'Ok',
            });
        } catch (error) {
            console.error(error);

            Swal.fire({
                title: 'Erro ao processar a inscrição!',
                text: error.message || '',
                icon: 'error',
                confirmButtonText: 'Ok',
            });
        } finally {
            processingRef.current = false;
            setIsProcessing(false);
        }
    };

    const renderFormularioAtleta = (atleta, index) => {
        const optionsMunicipios = listaMunicipios.map((municipio) => ({
            value: municipio.id,
            label: municipio.municipio,
        }));

        return (
            <div key={index} className="col-md-12 mb-5">
                <div className="row">
                    <div className="col-12">
                        <h4>Atleta {index + 1}</h4>
                    </div>

                    <div className="col-md-2">
                        <label>CPF *</label>
                        <input
                            maxLength="11"
                            type="text"
                            value={atleta.cpf}
                            className="form-control"
                            onChange={(e) => handleChangeCpf(index, e.target.value)}
                            onBlur={() => handleBlurCpf(index)}
                        />
                    </div>

                    <div className="col-md-5">
                        <label>Nome *</label>
                        <input
                            type="text"
                            maxLength="100"
                            value={atleta.nome}
                            className="form-control"
                            onChange={(e) => handleChangeAtleta(index, 'nome', e.target.value)}
                        />
                    </div>

                    <div className="col-md-5">
                        <label>Email *</label>
                        <input
                            type="email"
                            maxLength="100"
                            value={atleta.email}
                            className="form-control"
                            onChange={(e) => handleChangeAtleta(index, 'email', e.target.value)}
                        />
                    </div>

                    <div className="col-md-3 mt-3">
                        <label>Categoria/Faixa *</label>
                        <select
                            value={atleta.categoria_faixa}
                            className="form-control"
                            onChange={(e) =>
                                handleChangeAtleta(
                                    index,
                                    'categoria_faixa',
                                    e.target.value
                                )
                            }
                        >
                            <option value="0">::Selecione::</option>

                            {listaFaixas
                                .filter((faixa) => {
                                    if (evento?.tipoEvento === 3) {
                                        return faixa.id >= 9;
                                    }

                                    return true;
                                })
                                .map((faixa) => (
                                    <option key={faixa.id} value={faixa.id}>
                                        {faixa.faixa}
                                    </option>
                                ))
                            }
                        </select>
                    </div>

                    <div className="col-md-2 mt-3">
                        <label>Sexo *</label>
                        <select
                            value={atleta.sexo}
                            className="form-control"
                            onChange={(e) => {
                                const sexo = e.target.value;

                                handleChangeAtleta(index, 'sexo', sexo);

                                if (atleta.categoria) {
                                    atualizarCategoria(
                                        index,
                                        atleta.categoria,
                                        sexo
                                    );
                                }
                            }}
                        >
                            <option value="">::Selecione::</option>
                            <option value="Masculino">Masculino</option>
                            <option value="Feminino">Feminino</option>
                        </select>
                    </div>

                    <div className="col-md-3 mt-3">
                        <label>Data de Nascimento *</label>
                        <input
                            type="date"
                            value={atleta.data_nascimento}
                            className="form-control"
                            onChange={(e) =>
                                atualizarDadosNascimento(
                                    index,
                                    e.target.value
                                )
                            }
                        />
                    </div>

                    <div className="col-md-2 mt-3">
                        <label>Idade *</label>
                        <input
                            type="text"
                            value={atleta.idade ?? ''}
                            disabled
                            readOnly
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-2 mt-3">
                        <label>Município *</label>
                        <Select
                            options={optionsMunicipios}
                            value={
                                optionsMunicipios.find(
                                    (option) => option.value === atleta.municipio_id
                                ) || null
                            }
                            onChange={(selected) =>
                                handleChangeAtleta(
                                    index,
                                    'municipio_id',
                                    selected?.value || ''
                                )
                            }
                            placeholder="Buscar..."
                            isSearchable
                            noOptionsMessage={() => 'Nenhum município encontrado'}
                        />
                    </div>

                    <div className="col-md-4 mt-3">
                        <label>Categoria TK3 *</label>
                        <select
                            className="form-control"
                            value={atleta.categoria}
                            disabled={!atleta.maiorIdade}
                            onChange={(e) =>
                                atualizarCategoria(
                                    index,
                                    Number(e.target.value)
                                )
                            }
                        >
                            <option value="">::Selecione::</option>

                            {(atleta.categorias || []).map((categoria) => (
                                <option key={categoria.id} value={categoria.id}>
                                    {categoria.divisao}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4 mt-3">
                        <label>Peso (Kg) *</label>

                        {atleta.rangePeso ? (
                            <RangeSelect
                                range={atleta.rangePeso}
                                className="form-control"
                                value={atleta.peso || ''}
                                onChange={(value) =>
                                    handleChangeAtleta(
                                        index,
                                        'peso',
                                        value
                                    )
                                }
                                type="Kg"
                                disabled={!atleta.sexo || !atleta.categoria}
                            />
                        ) : (
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                placeholder="Selecione sexo e categoria"
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="row">
            <div className="col-12 mb-4">
                <div className="de_pricing-table type-2">
                    <div className="d-head">
                        <h3>Gyeorugi TK3</h3>
                    </div>

                    <div className="d-price">
                        <h4 className="opt-1">
                            Valor da equipe:{' '}
                            <ValorMonetario valor={evento.taxaGeral} />
                        </h4>
                    </div>

                    <div className="alert alert-info mt-3">
                        <strong>
                            A equipe TK3 deve ser formada por exatamente 3 atletas da mesma academia e da mesma categoria/divisão.
                        </strong>
                    </div>

                    {!pedido && !inscricaoFinalizada && (
                        <>
                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <label>Academia da Equipe *</label>
                                    <input
                                        type="text"
                                        maxLength="100"
                                        className="form-control"
                                        value={dadosEquipe.academia}
                                        onChange={(e) =>
                                            handleChangeEquipe(
                                                'academia',
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Técnico da Equipe *</label>
                                    <input
                                        type="text"
                                        maxLength="100"
                                        className="form-control"
                                        value={dadosEquipe.tecnico}
                                        onChange={(e) =>
                                            handleChangeEquipe(
                                                'tecnico',
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                            </div>

                            <hr className="mt-4 mb-4" />

                            <div className="row">
                                {atletas.map((atleta, index) =>
                                    renderFormularioAtleta(
                                        atleta,
                                        index
                                    )
                                )}
                            </div>

                            <div className="d-action">
                                <input
                                    type="button"
                                    value={
                                        evento.tipoEvento !== 3
                                            ? isProcessing
                                                ? 'Gerando Boleto...'
                                                : 'Efetuar Pagamento'
                                            : isProcessing
                                                ? 'Realizando Inscrição...'
                                                : 'Realizar Inscrição'
                                    }
                                    className="btn-main color-2"
                                    onClick={handleInscricao}
                                    disabled={isProcessing}
                                />
                            </div>
                        </>
                    )}

                    {inscricaoFinalizada && (
                        <div className="alert alert-success mt-4">
                            <h4>Inscrição TK3 realizada com sucesso!</h4>
                        </div>
                    )}

                    {pedido && (
                        <div ref={boxPedidoRef} className="mt-5">
                            <h4 className="opt-1">
                                <span>Boleto gerado com sucesso!</span>
                            </h4>

                            <p>
                                Seu boleto e QRCODE para pagamento estão disponíveis abaixo.
                            </p>

                            {pedido?.status !== 1 && (
                                <FormaPagamento pedido={pedido} />
                            )}

                            <p>
                                * Sua inscrição só será confirmada após a confirmação do PIX ou compensação do boleto.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}